/* eslint-disable @typescript-eslint/consistent-type-assertions */
import type { NewMachineResource, NewEndpointResource, ListeningTentacleEndpointResource, SshEndpointResource, AzureCloudServiceEndpointResource, AzureServiceFabricClusterEndpointResource, KubernetesEndpointResource, OfflineDropEndpointResource, StepPackageEndpointResource, CommunicationStyle, } from "@octopusdeploy/octopus-server-client";
import { CommunicationStyleValues, AzureCloudServiceEndpointDeploymentSlot, AzureServiceFabricSecurityMode, AADCredentialType, OfflineDropDestinationType, MachineModelHealthStatusValues } from "@octopusdeploy/octopus-server-client";
import SshEndpoint from "../MachineSettings/Endpoints/SshEndpoint";
export default function CreateNewMachineResource(location: URI, defaultMachinePolicyId: string): NewMachineResource {
    const query = location.search(true);
    const resourceName = (query.name as string) ?? "";
    let endpoint: NewEndpointResource = {
        CommunicationStyle: query.type as CommunicationStyle,
        Name: resourceName,
    };
    switch (endpoint.CommunicationStyle) {
        case CommunicationStyleValues.TentaclePassive: {
            const tentacleEndpoint = endpoint as ListeningTentacleEndpointResource;
            tentacleEndpoint.Uri = query.uri;
            tentacleEndpoint.Thumbprint = query.thumbprint;
            tentacleEndpoint.ProxyId = query.proxyId;
            endpoint = tentacleEndpoint;
            break;
        }
        case CommunicationStyleValues.Ssh: {
            const sshEndpoint = endpoint as SshEndpointResource;
            sshEndpoint.Uri = query.uri;
            sshEndpoint.Host = query.host;
            sshEndpoint.Port = query.port ? query.port : 22;
            sshEndpoint.Fingerprint = query.fingerprint;
            sshEndpoint.ProxyId = query.proxyId;
            sshEndpoint.DotNetCorePlatform = SshEndpoint.defaultDotnetCorePlatform;
            sshEndpoint.HostKeyAlgorithm = query.hostKeyAlgorithm;
            endpoint = sshEndpoint;
            break;
        }
        case CommunicationStyleValues.AzureCloudService: {
            const csEndpoint = endpoint as AzureCloudServiceEndpointResource;
            csEndpoint.Slot = AzureCloudServiceEndpointDeploymentSlot.Staging;
            csEndpoint.SwapIfPossible = true;
            csEndpoint.UseCurrentInstanceCount = true;
            endpoint = csEndpoint;
            break;
        }
        case CommunicationStyleValues.AzureServiceFabricCluster: {
            const fabricEndpoint = endpoint as AzureServiceFabricClusterEndpointResource;
            fabricEndpoint.SecurityMode = AzureServiceFabricSecurityMode.Unsecure;
            fabricEndpoint.AadCredentialType = AADCredentialType.UserCredential;
            endpoint = fabricEndpoint;
            break;
        }
        case CommunicationStyleValues.Kubernetes: {
            const kubernetesEndpoint = endpoint as KubernetesEndpointResource;
            endpoint = kubernetesEndpoint;
            break;
        }
        case CommunicationStyleValues.OfflineDrop: {
            const offlineDropEndpoint = endpoint as OfflineDropEndpointResource;
            offlineDropEndpoint.Destination = {
                DestinationType: OfflineDropDestinationType.Artifact,
            };
            break;
        }
        case CommunicationStyleValues.StepPackage: {
            const stepPackageEndpoint = endpoint as StepPackageEndpointResource;
            stepPackageEndpoint.DeploymentTargetTypeId = query.deploymentTargetTypeId;
            break;
        }
        default: {
            break;
        }
    }
    const machine: NewMachineResource = {
        MachinePolicyId: defaultMachinePolicyId,
        Name: resourceName ? resourceName : query.host,
        IsDisabled: false,
        HealthStatus: MachineModelHealthStatusValues.Unknown,
        HasLatestCalamari: true,
        IsInProcess: true,
        Endpoint: endpoint,
        ShellName: "",
    };
    return machine;
}
